<div class="wrapper-success-page">
    <h2>Consulta encerrada.</h2>
</div>
